import { styled } from 'styled-components';

export const CustomerReviewsSectionWrapper = styled.section`
  width: 100%;
  display: flex;
  justify-content: center;
  position: relative;
  padding: 64px 24px;
`;

export const CustomerReviewsSectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: ${({ theme }) => theme.content.maxWidth}px;
  gap: 48px;
  width: 100%;
`;

export const CustomerReviewsSectionContent = styled.div<{
  $extended?: boolean;
}>`
  gap: 24px;
  max-width: ${({ theme }) => theme.content.maxWidth}px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  max-height: ${({ $extended }) => ($extended ? '1500px' : '500px')};
  ${({ theme }) => theme.breakpoints.md.query} {
    grid-template-columns: repeat(2, 1fr);
  }
  ${({ theme }) => theme.breakpoints.sm.query} {
    grid-template-columns: repeat(1, 1fr);
  }
  overflow: clip;
`;
